import React, { Component } from "react";
import { debounce } from "lodash";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as ReportsActions } from "store/ducks/reports";
import {
  Creators as StoresActions,
  Selectors as StoresSelectors,
} from "store/ducks/stores";

import { Form } from "components";

class Filters extends Component {
  state = {
    id: '',
    types: [
      { value: "Experience::Point", label: "Pontos" },
      { value: "Experience::Voucher", label: "Voucher" },
      { value: "Experience::BulkPointsAssigner", label: "Atribuição de Pontos em Massa" },
      { value: "Store::Channel", label: "Canais" },
      { value: "Store::PaymentMethod", label: "Métodos de Pagamento" },
      { value: "Store::Place", label: "Lojas" },
      { value: "Experience::CustomerPointPrize", label: "Premiação" },
      { value: "Experience::VoucherConfiguration", label: "Tipo de Benefício" },
      { value: "Experience::CommercialCampaign", label: "Campanha Comercial" },
      { value: "User::DocumentRequest", label: "Documento" },
      { value: "Experience::VoucherInhabitant", label: "Voucher do habitante" },
      { value: "auth_groups", label: "Grupos" },
      { value: "auth_roles", label: "Permissões" },
      { value: "External::Redemption", label: "WebPrêmios"},
      { value: "User::Extraction", label: "Extrações"}
    ],
  };

  constructor(props) {
    super(props)

    this.handleChangeId = debounce(props.onChange, 300)
  }

  onChangeId = (value) => {
    this.setState({ id: value })
    this.handleChangeId('id', value)
  };

  render() {
    const { id, types } = this.state;
    const { data, onChange, onClean } = this.props;

    return (
      <Form className="row form-filters">
        <Form.Field className="col-md-3">
          <Form.Label>Tópico</Form.Label>
          <Form.Select
            placeholder="Tipo"
            value={data.auditable_type}
            options={types}
            onChange={(value) => onChange("auditable_type", value)}
          />
        </Form.Field>

        <Form.Field className="col-md-2 col-sm-4">
          <Form.Label>ID</Form.Label>
          <Form.Input
            value={id}
            onChange={(e) => this.onChangeId(e.target.value)}
          />
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Label>Período, de</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={data.date_start}
              onChange={(value) => onChange("date_start", value)}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Label>Período, até</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={data.date_end}
              onChange={(value) => onChange("date_end", value)}
              minDate={data.date_start}
              disabled={data.date_start === null}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Button className="button-clean-filter" onClick={onClean}>
            Resetar Filtro
          </Form.Button>
        </Form.Field>
      </Form>
    );
  }
}

const mapstate = (state) => ({
  reports: state.reports,
  stores: {
    ...state.stores,
    data: StoresSelectors.options(state.stores.data),
  },
});

const mapActions = (dispatch) =>
  bindActionCreators({ ...ReportsActions, ...StoresActions }, dispatch);

export default connect(mapstate, mapActions)(Filters);
